import { Text } from "@src/appV2/redesign/components/Text";

interface NavigationMenuSectionTitleTabletProps {
  children: React.ReactNode;
}

export function NavigationMenuSectionTitleTablet(props: NavigationMenuSectionTitleTabletProps) {
  const { children } = props;

  return (
    <Text
      bold
      variant="caption"
      sx={(theme) => ({
        color: theme.palette.navbar?.sectionTitle,
        flexShrink: 0,
        whiteSpace: "nowrap",
        textAlign: "center",
      })}
    >
      {children}
    </Text>
  );
}
